
import Api from '../../../helpers/Api';

// ACTION TYPES

export const SET_LAST_PLAYED_SONGS = 'SET_LAST_PLAYED_SONGS';
const setLastPlayedSongs = (lastPlayedSongs, metaId) => ({
    type: SET_LAST_PLAYED_SONGS,
    lastPlayedSongs,
    metaId,
});


// ACTIONS

export const fetchLastPlayedSongsIfNeeded = () => (dispatch, getState) => {
    const aovivoState = getState().aovivo;
    const updated = aovivoState.lastPlayedSongs.lastPlayedSongsUpdated;
    const lastMetaId = aovivoState.lastPlayedSongs.lastPlayedSongsMetaId;
    const currentMetaId = getState().aovivoBar.MediaPlayer.currentStream.metaId;
    const updateInterval = 1000 * 15; // 15 seconds as we check every 20 seconds for new meta data (this is mostly to avoid re-requesting this information on the client after initial render)

    if (lastMetaId !== currentMetaId || (Date.now() - updated) > updateInterval) {
        const url = `/api/v1/aovivo/getMetaHistory/${currentMetaId}`;

        return Api.progressGet(dispatch, url).then((json) => {
            if (json.status === 'success' && Array.isArray(json.data)) {
                return dispatch(setLastPlayedSongs(json.data, currentMetaId));
            }

            throw `error from server: ${json.message}`;
        }).catch((error) => {
            // eslint-disable-next-line no-console
            console.log('fetchLastPlayedSongs got error:', error);
        });
    }

    return Promise.resolve(1);
};

export const addLastPlayedSongIfNeeded = () => (dispatch, getState) => {
    const state = getState();
    const aovivoState = state.aovivo;
    const updated = aovivoState.lastPlayedSongs.lastPlayedSongsUpdated;
    const maxUpdatedTime = 1000 * 60 * 15; // 15 minutes

    if ((Date.now() - updated) > maxUpdatedTime) {
        // if the lastPlayedSongs have been updated too long ago, fetch the complete history from the server to not miss items
        // this can be the case if the user switched off the computer and returns on the next day...
        return dispatch(fetchLastPlayedSongsIfNeeded());
    }

    const musicLive = state.aovivoBar.NowPlaying.musicLive;

    if (musicLive.metaType !== 'music' && musicLive.metaType !== 'commercial') {
        // only add music and commercials
        return Promise.resolve(1);
    }

    let lastPlayedSongs = aovivoState.lastPlayedSongs.lastPlayedSongs;

    if (lastPlayedSongs[lastPlayedSongs.length - 1]?.time === musicLive.time) {
        // this entry is already there (that should only happen after the initial render)
        return Promise.resolve(1);
    }

    // Looks good, add the song to the list
    const lastPlayedSong = {
        album: musicLive.album,
        artist: musicLive.artist,
        artistId: musicLive.artistId, // Note: this is actually not used nowhere on the client, but keeping it to be conistant with the API
        artistSlug: musicLive.artistSlug,
        song: musicLive.song,
        songId: musicLive.songId, // Note: this is actually not used nowhere on the client, but keeping it to be conistant with the API
        musicSlug: musicLive.musicSlug,
        lyrics: !!musicLive.lyrics,
        lyricsTranslation: !!musicLive.lyricsTranslation,
        cover: musicLive.cover,
        itunes: musicLive.itunes,
        time: musicLive.time,
        year: musicLive.year,
        slug: musicLive.slug,
        spotSlug: musicLive.spotSlug,
        metaType: musicLive.metaType,
    };

    const currentMetaId = state.aovivoBar.MediaPlayer.currentStream.metaId;
    const maxNumLastPlayedSongs = 20; // Not sure if this is the best place to define this. If this will ever be variable, put it into the controller

    if (lastPlayedSongs.length >= maxNumLastPlayedSongs) {
        // remove the first element if we have already more items than maxNumLastPlayedSongs
        lastPlayedSongs = lastPlayedSongs.slice(1);
    }

    // add the new entry
    lastPlayedSongs = lastPlayedSongs.concat(lastPlayedSong);

    return dispatch(setLastPlayedSongs(lastPlayedSongs, currentMetaId));
};
